package meineglasfaser.frontend.admin.components.layouts

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.layout.Layout
import meineglasfaser.frontend.admin.components.AdminUserStateRedirectIfLoggedOut
import meineglasfaser.frontend.admin.components.sections.AdminSidebar
import org.jetbrains.compose.web.dom.Main

@Layout
@Composable
fun AdminLayout(content: @Composable () -> Unit) {
    AdminUserStateRedirectIfLoggedOut()
    AdminSidebar()
    Main {
        content()
    }
}
